var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21846",
    "data-name": "\\uADF8\\uB8F9 21846",
    transform: "translate(-451 -1341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28210",
    "data-name": "\\uC0AC\\uAC01\\uD615 28210",
    width: 23,
    height: 23,
    transform: "translate(451 1341)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21845",
    "data-name": "\\uADF8\\uB8F9 21845",
    transform: "translate(-42.733 11.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28208",
    "data-name": "\\uC0AC\\uAC01\\uD615 28208",
    width: 12.475,
    height: 17.698,
    rx: 2,
    transform: "translate(500.435 1330.9)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10298",
    "data-name": "\\uD328\\uC2A4 10298",
    d: "M13,22.365v.826a1.262,1.262,0,0,1-1.267,1.257H2.267A1.262,1.262,0,0,1,1,23.192V8.486A1.262,1.262,0,0,1,2.267,7.228H3.279",
    transform: "translate(496.556 1326.53)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_73",
    "data-name": "\\uC120 73",
    x2: 6.496,
    transform: "translate(503.461 1335.376)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_74",
    "data-name": "\\uC120 74",
    x2: 6.496,
    transform: "translate(503.461 1338.919)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_75",
    "data-name": "\\uC120 75",
    x2: 4.134,
    transform: "translate(503.461 1342.462)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon);
export default __webpack_public_path__ + "static/media/DetailIcon.58b7bf832e96f8456a56e6a919fef723.svg";
export { ForwardRef as ReactComponent };